import { useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { isLoadingAtom } from '@/store/loading'

export const LoginForm = () => {
  const setLoading = useSetAtom(isLoadingAtom)

  useEffect(() => {
    setLoading(true)
    window.location.href = '/auth/login'
  }, [])

  return null
}
